import { pureBreadcrumbState } from './breadcrumb';
import { userModelState } from './userModel';
import { followModelState } from './followModel';
import { articleModelState } from './articleModel';
import { tagModelState } from './tagModel';
import { editInfoModelState } from './editInfoModel';
import { askModelState } from './askModel';

const initialState = {
  ...pureBreadcrumbState,
  ...userModelState,
  ...followModelState,
  ...articleModelState,
  ...tagModelState,
  ...editInfoModelState,
  ...askModelState
};

export type IInitialState = Readonly<typeof initialState>;

export default initialState;
